import { action } from "satcheljs";
import type { OpenPstScenario } from "../store/schema/OpenPstFileExperienceStore";
import type { AccountConfigDialogLaunchOrigin } from "owa-account-config-shared";

/**
 * Dispatch this action to render the PST account configuration experience
 */
export interface ConfigureNewPstAccountActionMessage {
    scenario: OpenPstScenario;
    targetWindow: Window;
    entryPoint: AccountConfigDialogLaunchOrigin;
}
export const configureNewPstAccount: (targetWindow: Window, entryPoint: AccountConfigDialogLaunchOrigin) => ConfigureNewPstAccountActionMessage = action("configureNewPstAccount", (targetWindow: Window, entryPoint: AccountConfigDialogLaunchOrigin): ConfigureNewPstAccountActionMessage => ({
    scenario: "ConfigureNewPstAccount" as OpenPstScenario,
    targetWindow,
    entryPoint,
}));
